<template>
  <div class="">
    <span
      class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs uppercase"
      @click="$bus.$emit('modal-show', 'modal-sortby')"
    >
      {{ $t('sort') }}
    </span>
    <modal :name="'modal-sortby'">
      <div slot="content" class="pt0">
        <i
          slot="close"
          class="icon-close"
          @click="$bus.$emit('modal-hide', 'modal-sortby')"
          data-testid="closeModalButton"
        />
        <span class="block mx20 my10 sort-label cl-light-gray" :class="{ 'weight-600': variant.id === sortby.id }" v-for="variant in sortingVariants" :key="variant.id" @click="changeSort(variant)">
          {{ $t(variant.label) }}
        </span>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from 'theme/components/core/Modal.vue'
import SortBy from '@vue-storefront/core/compatibility/components/SortBy'
import { products } from 'config'

export default {
  components: {
    Modal
  },
  mixins: [SortBy],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sortby: null
    }
  },
  watch: {
    value: {
      handler () {
        const defaultVariant = this.value && this.value.length ? this.value : products.defaultSortBy.attribute
        this.sortby = this.sortingVariants.find(variant => variant.id.includes(defaultVariant))
      },
      immediate: true
    }
  },
  methods: {
    changeSort (variant) {
      this.sortby = variant
      this.changeOrder()
      this.$bus.$emit('modal-hide', 'modal-sortby')
    }
  }
}
</script>
<style lang="scss" scoped>
    @import '~theme/css/base/text';
    @import '~theme/css/variables/colors';
    @import '~theme/css/helpers/functions/color';
    $color-tertiary: color(tertiary);
    .sort-by {
        display: inline-flex;
        position: relative;
        select {
            @media (max-width: 990px) {
              max-width: initial;
            }
            max-width: 260px;
            font-size: 14px;
            width: 100%;
            border-radius: 0;
            background-color: transparent;
            margin-right: 0;
            padding: 3px;
            &:focus {
                outline: none;
            }
        }
    }
    @media (max-width: 770px) {
      .sort-by {
        width: 100%;
      }
    }
  .sort-label {
    font-size: 0.9em;
  }
  .icon-close {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #646464;
  }
</style>
